module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-19-e6ba2ef1b5e9a9f9f3092f3187ffee6f.svg";